import UserDashboard from "../User/UserDashboard";
import UserAppointments from "../User/UserAppointments";
import UserMedicalRecords from "../User/UserMedicalRecords";
import UserWishlist from "../User/UserWishlist";
import UserProfile from "../User/UserProfile";
import UserNotifications from "../User/UserNotifications";
import UserInsuranceDirectory from "../User/UserInsuranceDirectory";
import UserInsuranceAssistance from "../User/UserInsuranceAssistance";
import UserInsuranceCompanyPolicies from "../User/UserInsuranceCompanyPolicies";
import AdminProtectedRoute from "../ProtectedRoute";
import CommonLayout from "../layouts/CommonLayout";

const userRoutes = [
  { path: "/user-dashboard", element: <AdminProtectedRoute><CommonLayout><UserDashboard /></CommonLayout></AdminProtectedRoute> },
  { path: "/user-appointments", element: <AdminProtectedRoute><CommonLayout><UserAppointments /></CommonLayout></AdminProtectedRoute> },
  { path: "/medical-records", element: <AdminProtectedRoute><CommonLayout><UserMedicalRecords /></CommonLayout></AdminProtectedRoute> },
  { path: "/user-wishlist", element: <AdminProtectedRoute><CommonLayout><UserWishlist /></CommonLayout></AdminProtectedRoute> },
  { path: "/user-profile", element: <AdminProtectedRoute><CommonLayout><UserProfile /></CommonLayout></AdminProtectedRoute> },
  { path: "/user-profile/:sublink", element: <AdminProtectedRoute><CommonLayout><UserProfile /></CommonLayout></AdminProtectedRoute> },
  { path: "/user-notifications", element: <AdminProtectedRoute><CommonLayout><UserNotifications /></CommonLayout></AdminProtectedRoute> },
  { path: "/user-insurance", element: <AdminProtectedRoute><CommonLayout><UserInsuranceDirectory /></CommonLayout></AdminProtectedRoute> },
  { path: "/user-insurance/assistance", element: <AdminProtectedRoute><CommonLayout><UserInsuranceAssistance /></CommonLayout></AdminProtectedRoute> },
  { path: "/user-insurance/companies/:companyId", element: <AdminProtectedRoute><CommonLayout><UserInsuranceCompanyPolicies /></CommonLayout></AdminProtectedRoute> },
];

export default userRoutes;
